<!-- HomePage.vue - 毕业论文项目首页（崇拜感+搜索框+双按钮+进站弹窗） -->
<template>
	<div class="hero-wrapper">
		<!-- 动态粒子背景 -->
		<div class="particles-container" ref="particlesContainer"></div>

		<div class="hero-container">
			<!-- 品牌区：激发崇拜感的视觉 -->
			<div class="brand-zone">
				<div class="glow-text">⚡ You 优毕引擎</div>
				<div class="sub-brand">Future-Ready Digital Asset Hub</div>
				<div class="badge-row">
					<div class="tech-badge">✨ AI 驱动资源矩阵</div>
					<div class="tech-badge">💎 毕设破界 · 灵感加速器</div>
					<div class="tech-badge">🚀 2w+ 开发者信赖</div>
				</div>
			</div>

			<!-- 百度风格搜索框 -->
			<div class="search-master">
				<div class="search-container">
					<span class="search-icon">🔍</span>
					<input type="text" class="search-input" v-model="searchKeyword"
						placeholder="搜索毕设源码、设计资源、破解工具... 例: '智慧校园'" @keyup.enter="performSearch" />
					<button class="search-btn" @click="performSearch">
						搜一下 <span>✨</span>
					</button>
				</div>
				<div class="hot-keywords">
					<span v-for="kw in hotKeywords" :key="kw" class="keyword" @click="selectKeyword(kw)">
						{{ kw }}
					</span>
				</div>
			</div>

			<!-- 激发崇拜&消费欲望的双主按钮 -->
			<div class="action-buttons">
				<button class="btn-primary" @click="goToWorks('/works/data-viz')">
					🖼️ 殿堂级作品展示
					<span>→</span>
				</button>
				<button class="btn-secondary" @click="handleCrackResource">
					🔓 破解资源获取
					<span>⚡</span>
				</button>
			</div>

			<!-- 作品预览微缩模块（制造冲动） -->
			<div class="preview-section">
				<div class="preview-title">
					<span>✦ 高能分类前瞻 ✦</span>
				</div>
				<div class="preview-cards">
					<div v-for="work in featuredWorks" :key="work.id" class="mini-card" @click="goToWorks(work.path)">
						<div class="mini-icon">{{ work.icon }}</div>
						<div class="mini-name">{{ work.name }}</div>
						<div class="mini-desc">{{ work.desc }}</div>
					</div>
				</div>
			</div>

			<!-- 底部备案信息和联系方式 -->
			<div class="inspire-footer">
				<div class="footer-main">
					🌟 汇聚顶尖毕设创意 · 解锁全栈资源 | 每一次搜索都是灵感的迸发
				</div>
				<div class="footer-info">
					<div class="copyright">
						© 2025 You优毕引擎 |
						<a href="#" class="footer-link">冀ICP备2025101544号-4</a> |
						<a href="#" class="footer-link">冀公网安备13090202000777号</a>
					</div>
					<div class="contact-info">
						<span>📧 合作咨询: 18133560004</span>
						<span class="separator">|</span>
						<span>💬 QQ: 962027221</span>
						<span class="separator">|</span>
						<span>📱 微信: 18133560004</span>
					</div>
					<!-- <div class="social-links">
						<a href="#" class="social-icon">📘 GitHub</a>
						<a href="#" class="social-icon">🐦 技术社区</a>
						<a href="#" class="social-icon">📺 视频教程</a>
					</div> -->
					<div class="academic-notice">
						⚠️ 本站资源仅供学习研究使用，请勿用于商业用途
					</div>
				</div>
			</div>
		</div>

		<!-- 资源弹窗提示（破解资源） -->
		<div v-if="showResourceModal" class="resource-modal" @click.self="closeModal">
			<div class="modal-content">
				<div class="modal-header">
					<span>🎁</span>
					<strong>尊享资源已就绪</strong>
					<button class="modal-close" @click="closeModal">✕</button>
				</div>
				<div class="modal-body">
					「全套破解工具+毕设模板」限时学术通道
				</div>
				<div class="modal-footer">
					<button class="modal-btn" @click="goToResources">立即前往 ✨</button>
				</div>
			</div>
		</div>

		<!-- 进站欢迎弹窗（新增强调版） -->
		<div v-if="showWelcomeModal" class="web_notice" @click.self="closeWelcomeModal">
			<div class="notice-card">
				<!-- 移除了被限制账号的旧信息 -->
				<h1 class="notice-title">项目最多 质量最优 全网最全</h1>
				<h3 class="notice-contact">需要源码请联系：<span class="phone-highlight">18133560004</span></h3>
				<div class="notice-qrcode">
					<!-- 注意：请确保 ./img/123123.png 文件存在，或者替换为实际图片地址 -->
					<img src="./image/123.jpg" alt="扫码联系客服" style="vertical-align: middle;" height="260px"
						width="260px">
				</div>
				<div class="notice-actions">
					<a href="javascript:void(0);" class="notice-btn know-btn" @click="closeWelcomeModal">我已知晓</a>
					<!-- QQ客服链接 - 王睿版 -->
					<a href='https://qm.qq.com/cgi-bin/qm/qr?k=AO320dMbXbdv7q4_L0qHTJF0ur43Y4Bh' target='_blank'
						class="notice-btn qq-btn">
						<img src="./image/QQ.png" alt="QQ客服"
							style="vertical-align: middle; width: 20px; height: 20px; margin-right: 4px;">
						<span>人工客服</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HomePage',
		data() {
			return {
				searchKeyword: '',
				showResourceModal: false,
				showWelcomeModal: true, // 控制进站弹窗显示
				// hotKeywords: ['智能推荐系统', '数据可视化大屏', 'SpringBoot毕设', '破解资源合集', 'Vue3管理后台'],
				featuredWorks: [{
						id: 1,
						name: 'AI 论文选题助手',
						icon: '🤖',
						desc: '大模型+知识图谱',
						path: ''
					},
					{
						id: 2,
						name: '破解资源·逆向工具包',
						icon: '🔓',
						desc: '毕设常用环境一键部署',
						path: '/services'
					},
					{
						id: 3,
						name: '计算机程序',
						icon: '🏥',
						desc: '计算机系统定制',
						path: '/works/data-viz'
					},
					{
						id: 4,
						name: '汉语言文学',
						icon: '⚙️',
						desc: '汉语言',
						path: '/works/ui-design'
					},
					{
						id: 5,
						name: '经济管理',
						icon: '🌐',
						desc: '经济管理',
						path: '/works/web-dev'
					},
					{
						id: 6,
						name: '源码获取',
						icon: '📊',
						desc: '需要源码联系作者',
						path: '/contact'
					}
				],
				particles: [],
				animationTimer: null
			};
		},
		mounted() {
			this.createParticles();
			this.addRippleEffect();
			// 控制台输出诱惑语
			console.log('%c✨ You 优毕引擎 · 毕设灵感巅峰 ✨', 'color: #2dd4bf; font-size: 16px; font-weight: bold;');
			console.log('%c立即搜索，解锁殿堂级作品与破解资源 → 点燃学术创作！', 'color: #a855f7;');
		},
		beforeDestroy() {
			if (this.animationTimer) {
				clearInterval(this.animationTimer);
			}
		},
		methods: {
			// 创建粒子背景
			createParticles() {
				const container = this.$refs.particlesContainer;
				if (!container) return;
				container.innerHTML = '';
				const particleCount = 70;
				for (let i = 0; i < particleCount; i++) {
					const particle = document.createElement('div');
					particle.classList.add('particle');
					const size = Math.random() * 6 + 2;
					particle.style.width = size + 'px';
					particle.style.height = size + 'px';
					particle.style.left = Math.random() * 100 + '%';
					particle.style.animationDuration = Math.random() * 12 + 8 + 's';
					particle.style.animationDelay = Math.random() * 10 + 's';
					particle.style.opacity = Math.random() * 0.5 + 0.2;
					particle.style.background = `radial-gradient(circle, #2dd4bf, #a855f7)`;
					container.appendChild(particle);
				}
			},
			// 添加按钮涟漪效果
			addRippleEffect() {
				// 样式已在全局添加，方法留空
			},
			// 执行搜索
			performSearch() {
				const keyword = this.searchKeyword.trim();
				if (!keyword) {
					alert('🔍 输入毕设关键词，解锁海量灵感资源！');
					return;
				}
				alert(`✨ 开发中，期待接下来的使用`);
				// mergedList() {
				// 想法1//所有数据集合编程一个
				//找到该文件并且打开
				// this.listA.concat(this.listB, this.listC)
				//想法2//接入ai搜索
			// }
		},
		// 选择热门关键词
		selectKeyword(keyword) {
			this.searchKeyword = keyword;
			this.performSearch();
		},
		// 跳转作品展示页面
		goToWorks(path) {
			const keyword = path.trim();
			if (!keyword) {
				this.$router.push('/works/data-viz');
			} else {
				this.$router.push(keyword);
			}
		},
		// 破解资源获取
		handleCrackResource() {
			this.showResourceModal = true;
			// 5秒后自动关闭弹窗
			setTimeout(() => {
				if (this.showResourceModal) {
					this.showResourceModal = false;
				}
			}, 8000);
		},
		// 关闭资源弹窗
		closeModal() {
			this.showResourceModal = false;
		},
		// 跳转资源页面
		goToResources() {
			this.showResourceModal = false;
			this.$router.push('/services');
		},
		// 关闭欢迎弹窗
		closeWelcomeModal() {
			this.showWelcomeModal = false;
		}
	}
	};
</script>

<style scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.hero-wrapper {
		position: relative;
		min-height: 100vh;
		background: radial-gradient(circle at 10% 20%, #0a0f2a, #030617);
		overflow-x: hidden;
		font-family: 'Segoe UI', 'Poppins', 'Inter', system-ui, -apple-system, 'Roboto', sans-serif;
		color: #fff;
	}

	/* 粒子容器 */
	.particles-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		pointer-events: none;
		overflow: hidden;
	}

	.particle {
		position: absolute;
		border-radius: 50%;
		animation: floatParticle linear infinite;
		filter: blur(2px);
	}

	@keyframes floatParticle {
		0% {
			transform: translateY(100vh) translateX(0) scale(0.8);
			opacity: 0;
		}

		10% {
			opacity: 0.8;
		}

		90% {
			opacity: 0.6;
		}

		100% {
			transform: translateY(-20vh) translateX(30px) scale(1.2);
			opacity: 0;
		}
	}

	/* 主容器 */
	.hero-container {
		position: relative;
		z-index: 2;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 2rem 1.5rem;
		backdrop-filter: blur(2px);
	}

	/* 品牌区 */
	.brand-zone {
		text-align: center;
		margin-bottom: 2rem;
		animation: fadeInUp 0.8s ease-out;
	}

	.glow-text {
		font-size: 4.2rem;
		font-weight: 800;
		background: linear-gradient(135deg, #FFFFFF, #2dd4bf, #a855f7, #3b82f6);
		background-size: 300% 300%;
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
		animation: gradientShift 5s ease infinite;
		letter-spacing: -0.02em;
		margin-bottom: 0.5rem;
		text-shadow: 0 0 20px rgba(45, 212, 191, 0.3);
	}

	@keyframes gradientShift {
		0% {
			background-position: 0% 50%;
		}

		50% {
			background-position: 100% 50%;
		}

		100% {
			background-position: 0% 50%;
		}
	}

	.sub-brand {
		font-size: 1.2rem;
		color: #cbd5e6;
		letter-spacing: 2px;
		backdrop-filter: blur(4px);
		display: inline-block;
		padding: 0.3rem 1.2rem;
		border-radius: 40px;
		background: rgba(255, 255, 255, 0.05);
		border: 1px solid rgba(45, 212, 191, 0.3);
	}

	.badge-row {
		display: flex;
		justify-content: center;
		gap: 1.2rem;
		margin-top: 1.8rem;
		flex-wrap: wrap;
	}

	.tech-badge {
		background: rgba(15, 25, 45, 0.7);
		backdrop-filter: blur(8px);
		padding: 0.5rem 1.2rem;
		border-radius: 60px;
		font-size: 0.8rem;
		font-weight: 500;
		border-left: 2px solid #2dd4bf;
		letter-spacing: 0.5px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	}

	/* 搜索框 */
	.search-master {
		width: 100%;
		max-width: 760px;
		margin: 1.5rem auto;
		animation: fadeInUp 1s ease-out 0.1s backwards;
	}

	.search-container {
		background: rgba(20, 28, 48, 0.7);
		backdrop-filter: blur(12px);
		border-radius: 80px;
		padding: 0.3rem 0.3rem 0.3rem 1.8rem;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border: 1px solid rgba(45, 212, 191, 0.5);
		box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3), 0 0 15px rgba(45, 212, 191, 0.2);
		transition: all 0.3s;
	}

	.search-container:focus-within {
		border-color: #2dd4bf;
		box-shadow: 0 0 25px rgba(45, 212, 191, 0.4);
		transform: scale(1.01);
	}

	.search-icon {
		font-size: 1.4rem;
		color: #2dd4bf;
	}

	.search-input {
		flex: 1;
		background: transparent;
		border: none;
		padding: 0.9rem 0;
		font-size: 1.1rem;
		color: #ffffff;
		outline: none;
		font-weight: 400;
	}

	.search-input::placeholder {
		color: #94a3b8;
		font-weight: 400;
	}

	.search-btn {
		background: linear-gradient(95deg, #2dd4bf, #3b82f6);
		border: none;
		padding: 0.7rem 1.8rem;
		border-radius: 60px;
		color: white;
		font-weight: 600;
		font-size: 1rem;
		cursor: pointer;
		transition: 0.2s;
		display: flex;
		align-items: center;
		gap: 6px;
		letter-spacing: 1px;
	}

	.search-btn:hover {
		transform: scale(1.02);
		box-shadow: 0 0 15px rgba(45, 212, 191, 0.6);
		background: linear-gradient(95deg, #26b9a5, #2b6ef0);
	}

	.hot-keywords {
		margin-top: 1rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 0.8rem;
	}

	.keyword {
		font-size: 0.75rem;
		background: rgba(255, 255, 255, 0.08);
		padding: 0.3rem 1rem;
		border-radius: 40px;
		cursor: pointer;
		transition: all 0.2s;
		color: #cbd5e6;
		border: 1px solid rgba(45, 212, 191, 0.3);
	}

	.keyword:hover {
		background: #2dd4bf;
		color: #030617;
		border-color: #2dd4bf;
		transform: translateY(-2px);
	}

	/* 双按钮区域 */
	.action-buttons {
		display: flex;
		justify-content: center;
		gap: 2rem;
		margin: 2.5rem 0 3rem;
		flex-wrap: wrap;
		animation: fadeInUp 1s ease-out 0.2s backwards;
	}

	.btn-primary {
		background: linear-gradient(115deg, #2dd4bf, #0891b2);
		border: none;
		padding: 1rem 2.5rem;
		font-size: 1.1rem;
		font-weight: 700;
		border-radius: 60px;
		color: white;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 12px;
		box-shadow: 0 10px 20px -5px rgba(45, 212, 191, 0.4);
		transition: all 0.25s ease;
		letter-spacing: 1px;
	}

	.btn-secondary {
		background: rgba(20, 30, 55, 0.8);
		backdrop-filter: blur(8px);
		border: 1px solid rgba(168, 85, 247, 0.6);
		padding: 1rem 2.5rem;
		font-size: 1.1rem;
		font-weight: 700;
		border-radius: 60px;
		color: #e0e7ff;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 12px;
		transition: all 0.25s;
		box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
	}

	.btn-primary:hover {
		transform: translateY(-5px);
		box-shadow: 0 20px 30px -8px rgba(45, 212, 191, 0.6);
		background: linear-gradient(115deg, #1ec7b0, #0a6e8f);
	}

	.btn-secondary:hover {
		transform: translateY(-5px);
		background: rgba(168, 85, 247, 0.25);
		border-color: #a855f7;
		color: white;
		box-shadow: 0 0 20px rgba(168, 85, 247, 0.4);
	}

	/* 预览卡片 */
	.preview-section {
		max-width: 1200px;
		width: 100%;
		margin: 1rem auto 0;
		padding: 0 1rem;
	}

	.preview-title {
		text-align: center;
		font-size: 1rem;
		letter-spacing: 2px;
		margin-bottom: 1rem;
		color: #a0afcf;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
	}

	.preview-cards {
		display: flex;
		gap: 1.2rem;
		overflow-x: auto;
		padding-bottom: 0.8rem;
		scrollbar-width: thin;
		scrollbar-color: #2dd4bf #1e293b;
	}

	.preview-cards::-webkit-scrollbar {
		height: 4px;
	}

	.preview-cards::-webkit-scrollbar-track {
		background: #1e293b;
		border-radius: 10px;
	}

	.preview-cards::-webkit-scrollbar-thumb {
		background: #2dd4bf;
		border-radius: 10px;
	}

	.mini-card {
		min-width: 160px;
		background: rgba(15, 25, 45, 0.7);
		backdrop-filter: blur(12px);
		border-radius: 24px;
		padding: 1rem;
		text-align: center;
		border: 1px solid rgba(45, 212, 191, 0.3);
		transition: all 0.2s;
		cursor: pointer;
	}

	.mini-card:hover {
		transform: translateY(-5px);
		border-color: #2dd4bf;
		background: rgba(45, 212, 191, 0.15);
	}

	.mini-icon {
		font-size: 2.2rem;
		margin-bottom: 0.5rem;
	}

	.mini-name {
		font-weight: 600;
		font-size: 0.85rem;
	}

	.mini-desc {
		font-size: 0.7rem;
		color: #8da3cf;
		margin-top: 6px;
	}

	/* 底部 - 增强版 */
	.inspire-footer {
		margin-top: 3rem;
		width: 100%;
		border-top: 1px solid rgba(45, 212, 191, 0.2);
		padding-top: 1.5rem;
	}

	.footer-main {
		font-size: 0.8rem;
		text-align: center;
		color: #7f8ea3;
		margin-bottom: 1rem;
	}

	.footer-info {
		text-align: center;
		font-size: 0.75rem;
		color: #6b7280;
	}

	.copyright {
		margin-bottom: 0.5rem;
	}

	.footer-link {
		color: #7f8ea3;
		text-decoration: none;
		transition: color 0.2s;
	}

	.footer-link:hover {
		color: #2dd4bf;
		text-decoration: underline;
	}

	.contact-info {
		margin-bottom: 0.5rem;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		gap: 0.5rem;
	}

	.separator {
		color: #4b5563;
	}

	.social-links {
		margin-bottom: 0.5rem;
		display: flex;
		justify-content: center;
		gap: 1.2rem;
		flex-wrap: wrap;
	}

	.social-icon {
		color: #7f8ea3;
		text-decoration: none;
		font-size: 0.7rem;
		transition: all 0.2s;
	}

	.social-icon:hover {
		color: #2dd4bf;
		transform: translateY(-1px);
	}

	.academic-notice {
		font-size: 0.65rem;
		color: #6b7280;
		margin-top: 0.5rem;
		padding-top: 0.5rem;
		border-top: 1px solid rgba(45, 212, 191, 0.15);
	}

	/* ========= 进站欢迎弹窗样式（现代浮层设计） ========= */
	.web_notice {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.75);
		backdrop-filter: blur(10px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 2000;
		animation: fadeIn 0.25s ease-out;
	}

	.notice-card {
		background: linear-gradient(145deg, #ffffff, #f8fafc);
		border-radius: 48px;
		width: 90%;
		max-width: 460px;
		padding: 2rem 1.8rem 2rem;
		box-shadow: 0 30px 50px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(45, 212, 191, 0.3);
		text-align: center;
		transition: transform 0.2s;
		animation: scaleIn 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1);
	}

	@keyframes scaleIn {
		from {
			opacity: 0;
			transform: scale(0.92);
		}

		to {
			opacity: 1;
			transform: scale(1);
		}
	}

	.notice-title {
		font-size: 1.9rem;
		font-weight: 800;
		color: #1e293b;
		margin: 0 0 0.75rem 0;
		background: linear-gradient(120deg, #0f172a, #2dd4bf);
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}

	.notice-contact {
		font-size: 1.4rem;
		font-weight: 700;
		color: #b91c1c;
		margin-bottom: 1.2rem;
	}

	.phone-highlight {
		font-size: 1.6rem;
		background: #fee2e2;
		padding: 0.1rem 0.6rem;
		border-radius: 60px;
		display: inline-block;
	}

	.notice-qrcode {
		margin: 0.8rem 0 1rem;
		display: flex;
		justify-content: center;
	}

	.notice-qrcode img {
		border-radius: 24px;
		background: white;
		padding: 8px;
		box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
	}

	.notice-actions {
		display: flex;
		justify-content: center;
		gap: 1.2rem;
		margin-top: 1rem;
		flex-wrap: wrap;
	}

	.notice-btn {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 0.65rem 1.6rem;
		border-radius: 80px;
		font-weight: 600;
		font-size: 0.95rem;
		text-decoration: none;
		transition: all 0.2s ease;
		cursor: pointer;
		background: #f1f5f9;
		color: #1e293b;
		border: 1px solid #cbd5e1;
	}

	.know-btn {
		background: #2dd4bf;
		border: none;
		color: white;
		box-shadow: 0 2px 8px rgba(45, 212, 191, 0.4);
	}

	.know-btn:hover {
		background: #14b8a6;
		transform: translateY(-2px);
		box-shadow: 0 6px 14px rgba(45, 212, 191, 0.4);
	}

	.qq-btn {
		background: #ffffff;
		border: 1px solid #2dd4bf;
		color: #0f172a;
	}

	.qq-btn:hover {
		background: #e6fffa;
		border-color: #14b8a6;
		transform: translateY(-2px);
	}

	/* 原有的资源弹窗样式 */
	.resource-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
		backdrop-filter: blur(8px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
		animation: fadeIn 0.2s ease;
	}

	.modal-content {
		background: rgba(10, 20, 35, 0.95);
		backdrop-filter: blur(20px);
		border-radius: 28px;
		width: 90%;
		max-width: 380px;
		border: 1px solid rgba(45, 212, 191, 0.5);
		box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
		overflow: hidden;
	}

	.modal-header {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 1rem 1.5rem;
		background: rgba(45, 212, 191, 0.15);
		border-bottom: 1px solid rgba(45, 212, 191, 0.3);
	}

	.modal-header span {
		font-size: 1.5rem;
	}

	.modal-header strong {
		flex: 1;
		font-size: 1.1rem;
	}

	.modal-close {
		background: none;
		border: none;
		color: #94a3b8;
		font-size: 1.2rem;
		cursor: pointer;
		padding: 0 5px;
	}

	.modal-close:hover {
		color: #fff;
	}

	.modal-body {
		padding: 1.5rem;
		font-size: 0.9rem;
		color: #cbd5e6;
		text-align: center;
	}

	.modal-footer {
		padding: 1rem 1.5rem 1.5rem;
		display: flex;
		justify-content: center;
	}

	.modal-btn {
		background: linear-gradient(95deg, #2dd4bf, #3b82f6);
		border: none;
		padding: 0.6rem 1.8rem;
		border-radius: 40px;
		color: white;
		font-weight: 600;
		cursor: pointer;
		transition: 0.2s;
	}

	.modal-btn:hover {
		transform: scale(1.02);
		box-shadow: 0 0 12px rgba(45, 212, 191, 0.5);
	}

	/* 动画 */
	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(30px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	/* 响应式 */
	@media (max-width: 700px) {
		.glow-text {
			font-size: 2.6rem;
		}

		.search-container {
			padding: 0.2rem 0.2rem 0.2rem 1rem;
		}

		.search-btn {
			padding: 0.5rem 1.2rem;
			font-size: 0.9rem;
		}

		.btn-primary,
		.btn-secondary {
			padding: 0.7rem 1.8rem;
			font-size: 0.95rem;
		}

		.action-buttons {
			gap: 1rem;
		}

		.contact-info {
			flex-direction: column;
			gap: 0.3rem;
		}

		.separator {
			display: none;
		}

		.notice-title {
			font-size: 1.5rem;
		}

		.notice-contact {
			font-size: 1.2rem;
		}

		.phone-highlight {
			font-size: 1.3rem;
		}

		.notice-card {
			padding: 1.5rem;
		}
	}
</style>